import {
  AccountShieldIcon,
  ShoppingBagIcon,
  //HomeIcon,
  ProfileIcon,
} from 'kosmos-ui/lib';

import { TShopperBrowserSidebarSection } from './types';

export const SHOPPER_BROWSER_SIDEBAR_SECTIONS: TShopperBrowserSidebarSection[] =
  [
    // TODO: Activate when recommendation service MVP is done.
    // {
    //   _id: 'home',
    //   label: 'Inicio',
    //   icon: HomeIcon,
    // },
    {
      _id: 'profile',
      label: 'Perfil',
      icon: ProfileIcon,
    },
    {
      _id: 'orders',
      label: 'Mis compras',
      icon: ShoppingBagIcon,
    },
    {
      _id: 'account',
      label: 'Cuenta',
      icon: AccountShieldIcon,
    },
  ];
